import { render, staticRenderFns } from "./InlayDisplay.vue?vue&type=template&id=413f427c&scoped=true"
import script from "./InlayDisplay.vue?vue&type=script&lang=js"
export * from "./InlayDisplay.vue?vue&type=script&lang=js"
import style0 from "./InlayDisplay.vue?vue&type=style&index=0&id=413f427c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f427c",
  null
  
)

export default component.exports